import { createContext, useContext, useState } from "react";

const BiomedicalFiltersContext = createContext();

export const BiomedicalFiltersProvider = ({ children }) => {
  const [filters, setFilters] = useState({}); 

  const clearFilters = () => setFilters({});

  return (
    <BiomedicalFiltersContext.Provider value={{ filters, setFilters, clearFilters }}>
      {children}
    </BiomedicalFiltersContext.Provider>
  );
};

export const useBiomedicalFilters = () => useContext(BiomedicalFiltersContext);
